module.exports = __webpack_public_path__ + "img/img_19@2x.6269d931.png";